export default class CtaChartModel {
    name: string = '';
    value: number = 0;
    depth: number = 0;
    color: string = '';
    size: number = 0;
    nodeNameClass: string = '';

    constructor(obj?: Partial<CtaChartModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
